"use client";

import TeamErrorBoundary from "../../src/app/team/error";

export default TeamErrorBoundary;
